import { render, staticRenderFns } from "./ConversionClaimAccount.vue?vue&type=template&id=3014b6a0&scoped=true"
import script from "./ConversionClaimAccount.vue?vue&type=script&lang=ts"
export * from "./ConversionClaimAccount.vue?vue&type=script&lang=ts"
import style0 from "./ConversionClaimAccount.vue?vue&type=style&index=0&id=3014b6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3014b6a0",
  null
  
)

export default component.exports